import { trigger } from 'li-analytics'
import { _auth } from './lib'
import config from './config'

export function isEmpty(o) {
  return !Object.keys(o).length
}

export function getUser() {
  return _auth.getUser() || {}
}

export function getToken() {
  console.warn(
    "[appshell] 'util.getToken' is deprecated. Use 'auth.getToken' instead"
  )
  return _auth.getToken()
}

export function isAuthenticated() {
  return !!getUser().authenticated && !!_auth.getToken()
}

export function isFullyAuthenticated() {
  const user = getUser()
  return !!(isAuthenticated() && user.verified)
}

export function getAppDotSubdomain() {
  const { hostname } = window.location

  return !hostname || hostname.indexOf('dev') > -1 || hostname === 'localhost'
    ? 'dev-app'
    : 'app'
}

export function getAppDotOrigin() {
  return `https://${getAppDotSubdomain()}.labelinsight.com`
}

export function pathnameIncludes(str) {
  return window.location.pathname.includes(str)
}

export function windowReload() {
  window.location.reload()
}

export function getEffectiveUser() {
  return _auth.getImpersonatedUser() || getUser()
}

export function hasRole(role, user) {
  return ((user || {}).roles || []).includes(role)
}

export function hasPublisherAccess(user) {
  return hasApplication(config.applicationIds.publish, user)
}

export function hasExploreAccess(user) {
  return hasApplication(config.applicationIds.explore, user)
}

export function hasExploreSpecsAccess(user) {
  return hasApplication(config.applicationIds.exploreSpecs, user)
}

export function hasCaptureAccess(user) {
  return hasApplication(config.applicationIds.capture, user)
}

export function toFormData(object) {
  const formData = new FormData()

  Object.keys(object).forEach(key => {
    formData.append(key, object[key])
  })

  return formData
}

export function getPathname() {
  return global.location.pathname
}

export function tourName(name) {
  return `app-shell-${name}`
}

export function getItem(key) {
  try {
    const value = localStorage.getItem(key)
    return /^[{[]/i.test(value) ? JSON.parse(value) : value
  } catch (e) {
    console.warn('getItem:', e)
  }

  return undefined
}

export function setItem(key, value) {
  try {
    localStorage.setItem(
      key,
      typeof value === 'object' || Array.isArray(value)
        ? JSON.stringify(value)
        : value
    )
  } catch (e) {
    console.warn('setItem:', e)
  }
}

export function blobToArrayBuffer(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onerror = event => {
      reject(event)
    }

    reader.onloadend = () => {
      resolve(reader.result)
    }

    reader.readAsArrayBuffer(file)
  })
}

export function millisToHours(ms) {
  return ms / 1000 / 60 / 60
}

export function track(fields) {
  if (window.dataLayer) {
    trigger('APP_SHELL_TRACK', {
      appShell: {
        category: fields.category || 'general',
        ...['event', 'label', 'property', 'value'].reduce((acc, key) => {
          const value = fields[key]
          acc[key] = value == null ? undefined : value
          return acc
        }, {}),
      },
    })
  }
}

track.userMenu = fields =>
  track({
    category: 'userMenu',
    ...fields,
  })

track.helpCenter = fields =>
  track({
    category: 'helpCenter',
    ...fields,
  })

export function isRestrictedApplication(appId) {
  return config.restrictedApplications.includes(appId)
}

export function isAuthorized({ appId, user, pathname }) {
  return (
    /explore\/product/.test(pathname) ||
    !isRestrictedApplication(appId) ||
    ((appId === 'capture' && hasCaptureAccess(user)) ||
      (appId === 'publish' && hasPublisherAccess(user)) ||
      (/explore/.test(appId) &&
        (hasExploreAccess(user) || hasExploreSpecsAccess(user))))
  )
}

export function hasApplication(applicationId, user) {
  return !!Object.keys(((user || {}).data || {}).permissions || {}).find(
    key => user.data.permissions[key].applicationId === applicationId
  )
}



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/util.js